import { Component, Input } from "@angular/core";
import { Fiat, Conversion } from "@models";
import { Tradable } from "@models/interfaces/tradable";
import { convertFiatToTradable, toCurrencyByFiatId } from "@helpers/tradable-convert";
import { MasterdataService } from "@core-services/masterdata.service";
import { PaymentsCryptocoin } from "@modules/+new/payments/shared-payments/entities/payments-cryptocoin.model";
import { AccountService } from "@modules/account/services/account.service";
import { TRADABLES_TYPE } from "@helpers/constants";

@Component({
	selector: "tradable-amount-tile",
	templateUrl: "./tradable-amount-tile.component.html",
	styleUrls: ["./tradable-amount-tile.component.scss"],
	standalone: false
})
export class TradableAmountTileComponent {
	@Input()
	public amount: number = 0;
	@Input()
	public tradable: Tradable = null;
	@Input()
	public multichainTradable: PaymentsCryptocoin = null;
	@Input()
	public all: boolean = false;
	@Input()
	public fiat: Fiat = null;
	@Input()
	public inverse: boolean = false;
	@Input()
	public bfcOptIn: boolean = false;
	@Input()
	public showSmallAmount: boolean = true;
	@Input()
	public removePrecision: boolean = true;

	@Input()
	public conversion: Conversion = null;

	public assetType = TRADABLES_TYPE;

	public constructor(
		protected masterdataService: MasterdataService,
		protected accountService: AccountService
	) {}

	public get tradableAmount(): number {
		if (this.conversion != null) {
			return this.bfcOptIn ? +this.conversion.cryptoBfc : +this.conversion.tradableAmount();
		}
		if (this.fiat == null) {
			this.fiat = this.accountService.getDefaultFiat();
		}
		return convertFiatToTradable(this.fiat, this.amount, this.tradable);
	}

	public getAmount(): number {
		if (this.conversion != null) {
			return this.bfcOptIn ? +this.conversion.fiatBfc : +this.conversion.getFiat();
		}
		if (!this.all || this.fiat == null) {
			return this.amount;
		}
		if (!this.fiat) {
			return 0;
		}
		return toCurrencyByFiatId(this.amount, this.fiat);
	}
}
